import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M7.4 12a.6.6 0 0 1 .6-.6h8a.6.6 0 1 1 0 1.2H8a.6.6 0 0 1-.6-.6Zm4.6 8.8a8.8 8.8 0 1 0 0-17.6 8.8 8.8 0 0 0 0 17.6ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      clip-rule="evenodd"
    />
  </svg>
`;
